module.exports = __webpack_public_path__ + "img/116.033343dc.jpg";